import { create } from "apisauce";

import authStorage from "@/auth/storage";

const apiUrl = import.meta.env.VITE_WEBSITE_URL + import.meta.env.VITE_API_PREFIX;  
const apiClient = create({
  baseURL: apiUrl,
});

apiClient.addAsyncRequestTransform(async (request) => {
  const token = authStorage.getToken();
  if (token) request.headers['x-auth-token'] = token;
});

apiClient.addAsyncResponseTransform(async (response, b) => {
  if(response.status === 401) {
    authStorage.removeToken();
    localStorage.removeItem("user");
    window.location.href = "/auth/login";
  }
});

export default apiClient;
